import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';
export const TRADE_TYPES = [
  'AllotTrade',
  'RedeemTrade',
  'AchievementPayTrade',
  'CashDividendTrade',
  'DividendReinvestmentTrade',
]

const entityColumns = {
  id: {
    model_name: 'Trade',
    column_type: 'id',
  },
  created_at: {
    model_name: 'Trade',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'Trade',
    column_type: 'datetime',
  },
  type: {
    model_name: 'Trade',
    column_type: 'type',
    extra: {
      options: ['AllotTrade', 'RedeemTrade', 'AchievementPayTrade', 'CashDividendTrade', 'DividendReinvestmentTrade'],
    },
  },
  amount: {
    model_name: 'Trade',
    column_type: 'decimal',
  },
  share: {
    model_name: 'Trade',
    column_type: 'decimal',
  },
  value: {
    model_name: 'Trade',
    column_type: 'decimal',
  },
  account: {
    model_name: 'Trade',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'account',
      model_name: 'Account',
      foreign_key: 'account_id',
    },
  },
  account_id: {
    model_name: 'Trade',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'account',
      model_name: 'Account',
      foreign_key: 'account_id',
    },
  },
  fund: {
    model_name: 'Trade',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'fund',
      model_name: 'Fund',
      foreign_key: 'fund_id',
    },
  },
  fund_id: {
    model_name: 'Trade',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'fund',
      model_name: 'Fund',
      foreign_key: 'fund_id',
    },
  },
  confirm_date: {
    model_name: 'Trade',
    column_type: 'date',
  },
  state: {
    model_name: 'Trade',
    column_type: 'enum',
  },
  parent: {
    model_name: 'Trade',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'parent',
      model_name: 'Trade',
      foreign_key: 'parent_id',
    },
  },
  parent_id: {
    model_name: 'Trade',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'parent',
      model_name: 'Trade',
      foreign_key: 'parent_id',
    },
  },
  name: {
    model_name: 'Trade',
    column_type: 'string',
  },
  confirm_file: {
    model_name: 'Trade',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
}

export const columnsExtend = (columns, filterColumnsExtend) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns, filterColumnsExtend)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
